<template lang="pug">
div
  Form(:data="worker", :isSubmitting="isSubmitting", :isPCUploadVisible="true", @submit="create")
  WorkerPermissions(
    v-if="role === 'consultant'"
    :isLoading="permIsLoading"
    :groups="permGroups"
    :expanded="permExpanded"
    :allExpanded="permAllExpanded"
    :hasOverrides="permHasOverrides"
    :toggleAll="permToggleAll"
    :viewMode="permViewMode"
    :setViewMode="permSetViewMode"
    :toggleAction="permToggleAction"
    :resetOverride="permResetOverride"
    :isCreateMode="true"
  )
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import Form from '../shared/Form.vue'
import WorkerPermissions from '../edit/WorkerPermissions.vue'
import useWorkerPermissionOverride from '@/composables/useWorkerPermissionOverride'
import store from '@/store'
// eslint-disable-next-line import/no-cycle
import useWorkerAdd from './useWorkerAdd'

export default {
  components: {
    Form,
    WorkerPermissions,
  },

  setup() {
    const { create, isSubmitting } = useWorkerAdd()
    const { role } = store.state?.userStore?.userData

    const worker = ref({ isPCUploadEnabled: false, privileges: "employee", isComplaintManager: true, realEmail: '' })

    const {
      isLoading: permIsLoading,
      groups: permGroups,
      expanded: permExpanded,
      allExpanded: permAllExpanded,
      toggleAll: permToggleAll,
      viewMode: permViewMode,
      setViewMode: permSetViewMode,
      toggleAction: permToggleAction,
      hasOverrides: permHasOverrides,
      resetOverride: permResetOverride,
      fetchDefault,
      fetchAll,
    } = useWorkerPermissionOverride(worker)

    // Cargar permisos iniciales en modo creación
    fetchAll()

    // Watch para actualizar permisos cuando cambia el privilege seleccionado
    watch(() => worker.value.privileges, async (newPrivilege) => {
      if (newPrivilege) {
        await fetchDefault(newPrivilege)
      }
    })

    return {
      worker,
      create,
      isSubmitting,
      role,
      permIsLoading,
      permGroups,
      permExpanded,
      permAllExpanded,
      permToggleAll,
      permViewMode,
      permSetViewMode,
      permToggleAction,
      permHasOverrides,
      permResetOverride,
    }
  },
}
</script>
